export const SOLICITATION_EVIDENCE_MAX_FILES = 5;
export const SOLICITATION_EVIDENCE_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const SOLICITATION_EVIDENCE_ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'pdf', 'txt', 'log'] as const;

export type SolicitationEvidenceRejectionReason = 'FORMAT' | 'SIZE' | 'COUNT';

export type SolicitationEvidenceRejection = {
    file: File;
    reason: SolicitationEvidenceRejectionReason;
};

export type SolicitationEvidenceValidationResult = {
    accepted: File[];
    rejected: SolicitationEvidenceRejection[];
};

const ALLOWED_EXTENSIONS = new Set<string>(SOLICITATION_EVIDENCE_ALLOWED_EXTENSIONS);

function getFileExtension(fileName: string): string {
    const parts = fileName.split('.');
    if (parts.length < 2) {
        return '';
    }
    return (parts[parts.length - 1] ?? '').toLowerCase();
}

export function validateSolicitationEvidenceFiles(candidates: File[], alreadySelected: number): SolicitationEvidenceValidationResult {
    const accepted: File[] = [];
    const rejected: SolicitationEvidenceRejection[] = [];

    for (const file of candidates) {
        const extension = getFileExtension(file.name);
        if (!ALLOWED_EXTENSIONS.has(extension)) {
            rejected.push({ file, reason: 'FORMAT' });
            continue;
        }
        if (file.size > SOLICITATION_EVIDENCE_MAX_FILE_SIZE_BYTES) {
            rejected.push({ file, reason: 'SIZE' });
            continue;
        }
        if (alreadySelected + accepted.length >= SOLICITATION_EVIDENCE_MAX_FILES) {
            rejected.push({ file, reason: 'COUNT' });
            continue;
        }
        accepted.push(file);
    }

    return { accepted, rejected };
}
